(() => {
  const SOCIAL_SOURCES = ['Instagram', 'Facebook', 'TikTok', 'Pinterest'];

  const ALLOWED_SOURCES = [
    'Instagram',
    'Facebook',
    'TikTok',
    'Google',
    'ChatGPT / AI',
    'Pinterest',
    'Email',
    'Friend / Family',
    'Other'
  ];

  let saveQueue = Promise.resolve();
  let latestSaveVersion = 0;
  let textSaveTimer = null;

  function getActiveDetailGroup(source) {
    if (source === 'Google') return 'Google';
    if (source === 'ChatGPT / AI') return 'ChatGPT / AI';
    if (source === 'Other') return 'Other';
    if (SOCIAL_SOURCES.includes(source)) return 'social';

    return null;
  }

  function getSelectedSource(component) {
    const checkedSource = component.querySelector(
      '[data-attribution-source]:checked'
    );

    return checkedSource ? checkedSource.value : '';
  }

  function getCurrentDetail(component, source) {
    const activeGroup = getActiveDetailGroup(source);

    if (!activeGroup) return '';

    const group = component.querySelector(
      `[data-attribution-detail-group="${CSS.escape(activeGroup)}"]`
    );

    if (!group) return '';

    const field = group.querySelector('[data-attribution-detail]');

    return field ? field.value.trim() : '';
  }

  function isValid(component) {
    const source = getSelectedSource(component);
    const detail = getCurrentDetail(component, source);

    if (!ALLOWED_SOURCES.includes(source)) {
      return false;
    }

    if (source === 'Other' && detail === '') {
      return false;
    }

    return true;
  }

  function getCheckoutButton(component) {
    const form = component.closest('form');

    if (!form) return null;

    return form.querySelector(
      'button[name="checkout"], input[name="checkout"]'
    );
  }

  function setCheckoutLocked(component, locked) {
  const checkoutButton = getCheckoutButton(component);

  if (!checkoutButton) return;

  checkoutButton.setAttribute('aria-disabled', locked ? 'true' : 'false');

  if (locked) {
    checkoutButton.dataset.attributionLocked = 'true';
    checkoutButton.classList.add('is-attribution-locked');
  } else {
    delete checkoutButton.dataset.attributionLocked;
    checkoutButton.classList.remove('is-attribution-locked');
  }
}

  function showMessage(component, show) {
    const message = component.querySelector('[data-attribution-message]');

    if (!message) return;

    message.hidden = !show;
  }

  function updateAttributionComponent(component, clearInactive = false) {
    const source = getSelectedSource(component);
    const activeGroup = getActiveDetailGroup(source);

    component
      .querySelectorAll('.lacorine-attribution__choice')
      .forEach((choice) => {
        const input = choice.querySelector('[data-attribution-source]');

        choice.classList.toggle(
          'is-selected',
          Boolean(input && input.checked)
        );
      });

    component
      .querySelectorAll('[data-attribution-detail-group]')
      .forEach((group) => {
        const groupName = group.dataset.attributionDetailGroup;
        const isActive = groupName === activeGroup;

        group.hidden = !isActive;

        group
          .querySelectorAll('[data-attribution-detail]')
          .forEach((field) => {
            field.disabled = !isActive;

            if (!isActive && clearInactive) {
              field.value = '';
            }
          });
      });

    const clearButton = component.querySelector('[data-attribution-clear]');

if (clearButton) {
  clearButton.hidden = source === '';
}

const valid = isValid(component);
component.classList.toggle('is-invalid', !valid);

setCheckoutLocked(component, !valid);
showMessage(component, !valid);
  }

  function buildCartUpdateUrl() {
    const root =
      window.Shopify &&
      window.Shopify.routes &&
      window.Shopify.routes.root
        ? window.Shopify.routes.root
        : '/';

    return `${root}cart/update.js`;
  }

  function queueSave(component) {
    const source = getSelectedSource(component);
    const detail = getCurrentDetail(component, source);

    const version = ++latestSaveVersion;

    setCheckoutLocked(component, true);

    saveQueue = saveQueue
      .catch(() => {})
      .then(async () => {
        if (version !== latestSaveVersion) return;

        const response = await fetch(buildCartUpdateUrl(), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            attributes: {
              'Attribution source': source,
              'Attribution detail': detail
            }
          })
        });

        if (!response.ok) {
          throw new Error('Unable to save attribution information.');
        }

        const cart = await response.json();

        const savedSource =
          cart.attributes &&
          cart.attributes['Attribution source']
            ? cart.attributes['Attribution source']
            : '';

        const savedDetail =
          cart.attributes &&
          cart.attributes['Attribution detail']
            ? cart.attributes['Attribution detail']
            : '';

        if (savedSource !== source || savedDetail !== detail) {
          throw new Error('Saved attribution information did not match.');
        }

        if (version === latestSaveVersion) {
          updateAttributionComponent(component);
        }
      })
      .catch((error) => {
        console.error('[Lacorine attribution]', error);

        setCheckoutLocked(component, true);

        const message = component.querySelector(
          '[data-attribution-message]'
        );

        if (message) {
          message.textContent =
            'We could not save your answer. Please try again before continuing.';
          message.hidden = false;
        }
      });
  }

  function scheduleTextSave(component) {
    clearTimeout(textSaveTimer);

    setCheckoutLocked(component, true);

    textSaveTimer = setTimeout(() => {
      queueSave(component);
    }, 600);
  }

  function initialiseAttributionComponents(root = document) {
    root.querySelectorAll('[data-cart-attribution]').forEach((component) => {
      if (component.dataset.attributionInitialised === 'true') return;

      component.dataset.attributionInitialised = 'true';

      updateAttributionComponent(component);
    });
  }
document.addEventListener('click', (event) => {
  const clearButton = event.target.closest('[data-attribution-clear]');

  if (!clearButton) return;

  const component = clearButton.closest('[data-cart-attribution]');

  if (!component) return;

  component
    .querySelectorAll('[data-attribution-source]')
    .forEach((input) => {
      input.checked = false;
    });

  component
    .querySelectorAll('[data-attribution-detail]')
    .forEach((field) => {
      field.value = '';
    });

  updateAttributionComponent(component, true);
  setCheckoutLocked(component, true);
  queueSave(component);
});
  document.addEventListener('change', (event) => {
    const sourceInput = event.target.closest('[data-attribution-source]');

    if (sourceInput) {
      const component = sourceInput.closest('[data-cart-attribution]');

      if (!component) return;

      updateAttributionComponent(component, true);
      setCheckoutLocked(component, true);
      queueSave(component);

      return;
    }

    const detailField = event.target.closest('[data-attribution-detail]');

    if (detailField) {
      const component = detailField.closest('[data-cart-attribution]');

      if (!component) return;

      setCheckoutLocked(component, true);
      queueSave(component);
    }
  });

  document.addEventListener('input', (event) => {
    const detailField = event.target.closest(
      '[data-attribution-detail][type="text"]'
    );

    if (!detailField) return;

    const component = detailField.closest('[data-cart-attribution]');

    if (!component) return;

    updateAttributionComponent(component);
    scheduleTextSave(component);
  });

  document.addEventListener(
  'click',
  (event) => {
    const checkoutButton = event.target.closest(
      'button[name="checkout"], input[name="checkout"]'
    );

    if (!checkoutButton) return;

    const form = checkoutButton.closest('form');

    if (!form) return;

    const component = form.querySelector('[data-cart-attribution]');

    if (!component) return;

    const locked =
      checkoutButton.dataset.attributionLocked === 'true' ||
      !isValid(component);

    if (!locked) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    component.classList.add('is-invalid');
    showMessage(component, true);

    component.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest'
    });
  },
  true
);
  document.addEventListener('submit', (event) => {
    const form = event.target;

    if (!(form instanceof HTMLFormElement)) return;

    const component = form.querySelector('[data-cart-attribution]');

    if (!component) return;

    const submitter = event.submitter;

    if (!submitter || submitter.name !== 'checkout') return;

    if (!isValid(component)) {
      event.preventDefault();

      setCheckoutLocked(component, true);
      showMessage(component, true);

      component.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest'
      });
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initialiseAttributionComponents();
    });
  } else {
    initialiseAttributionComponents();
  }

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (!(node instanceof Element)) return;

        if (node.matches('[data-cart-attribution]')) {
          initialiseAttributionComponents(node.parentElement || document);
          return;
        }

        if (node.querySelector('[data-cart-attribution]')) {
          initialiseAttributionComponents(node);
        }
      });
    });
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
